import axios from "axios";
import { BASE_URL_API } from "config";

export const processApiResponseError = (
    error,
    defaultErrorMessage = "Oops! Something went wrong. Please try again later.",
    additionMessage = ""
) => {
    let errorMessage = defaultErrorMessage;
    let errors = null;

    if (error) {
        const { statusText, message, response } = error;
        const data = response?.data || {};
        errorMessage = data.message || message || statusText;
        errors = data.errors;
    }

    if (additionMessage) {
        errorMessage += `\n\n${additionMessage}`;
    }

    error.message = errorMessage;
    if(errors){
        error.errors = errors;
    }

    throw error;
};

export const ApiCreator = baseUrl => {
    const fetchCreator = method => (url, data, headers) => {
        const requestHeaders = {
            accept: "application/json",
            "content-type": "application/json;charset=utf-8",
            ...headers
        };

        const requestConfig = {
            headers: requestHeaders,
            withCredentials: true,
            method,
            data: JSON.stringify(data)
        };

        return axios(`${baseUrl}/${url}`, requestConfig)
            .then(response => response.data)
            .catch(processApiResponseError);
    };

    return {
        get: fetchCreator("GET"),
        post: fetchCreator("POST"),
        patch: fetchCreator("PATCH"),
        delete: fetchCreator("DELETE"),
        put: fetchCreator("PUT")
    };
};

const client = ApiCreator(BASE_URL_API());

export default client;
